module.exports = __webpack_public_path__ + "img/isotipo.c9c277d8.png";